import * as React from "react"
import { NavLink } from "react-router-dom"

import Block from "@bappweb/block"
import LogoAkbank from "@components/globalmodules/logo"
import Events, { EVENT_TYPES } from "@utils/events"
import "./style.scss"
import Link from "@bappweb/link"
import Icon from "@bappweb/icon"
import { Sizes, useDeviceSize } from "@bappweb/provider"
import Element from "@bappweb/element"

const MobileMenu = () => {

  const size = useDeviceSize()
  const [open, setOpen] = React.useState(false)

  const handleMenu = React.useCallback((open: boolean) => {
    setOpen(open)
  }, [])

  const closeMenu = React.useCallback(() => {
    setOpen(false)
  }, [])

  React.useEffect(() => {
    Events.on(EVENT_TYPES.menu, handleMenu)

    return () => {
      Events.off(EVENT_TYPES.menu, handleMenu)
    }
  }, [handleMenu])

  React.useEffect(() => {
    setOpen(false)
  }, [size])

  if (!open || size !== Sizes.xs) {
    return null
  }

  return (
    <Block className="bapp-mobile-menu">
      <Block className="bapp-mobile-menu-backdrop" onClick={closeMenu} />
      <Block className="bapp-mobile-menu-wrapper">
        <Block type="header" className="bapp-mobile-menu-header">
          <Block className="bapp-mobile-menu-header-wrapper bapp-container">
            <Element className="bapp-header-logo">
              <NavLink to="/" className="bapp-link" onClick={closeMenu}>
                <LogoAkbank />
              </NavLink>
            </Element>
            <Link onClick={closeMenu}>
              <Icon name={Icon.Icons.NavigationClose} />
            </Link>
          </Block>
        </Block>
        <Block type="nav" className="bapp-mobile-menu-nav">
       
        
      
         
        </Block>
      </Block>
    </Block>
  )
}

export default MobileMenu
